export default __webpack_public_path__ + "static/media/supervisees-empty-state.96b73f15.svg";